<template>
  <Breadcrumbs
    title="Dealer VAT Report"
    :breadcrumbs="[
      { label: 'Sales', path: '' },
      { label: 'Invoices', path: '/invoice' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <DealerVatReportForm />
    </div>
  </div>
</template>

<script>
import DealerVatReportForm from './delaervat_form.vue';

export default {
  name: 'DealerVatReport',
  components: {
    DealerVatReportForm,
  },
};
</script>

